import { Grid2, Skeleton } from "@mui/material"
import { memo } from "react"

const TranslationSkeleton = memo(() => {
    return (
        <Grid2 container size={12} flexDirection={'column'} paddingBottom={4}>
            <Grid2 maxWidth={300}>
                <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
            </Grid2>
            {Array.from({ length: 1 }).map((objType, i) =>
                <Grid2 container key={i} flexDirection={"column"} spacing={2}>
                    <Grid2 container paddingTop={i !== 0 ? 4 : 0}>
                        <Grid2 size={"auto"} minWidth={200} display={{ xs: 'none', sm: 'flex' }}>
                            <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
                        </Grid2>
                        {["English", "Arabic", "Chinese"].map((l, i) => (
                            <Grid2 size={"grow"} key={i}>
                                <Skeleton variant="rounded" width={'100%'} />
                            </Grid2>
                        ))}
                        {/* <Grid2 minWidth={100}>
                        </Grid2> */}
                    </Grid2>
                    {Array.from({ length: 3 }).map((t, i) => (
                        <Grid2 container>
                            <Grid2 size={"auto"} minWidth={200} display={{ xs: 'none', sm: 'flex' }}>
                                <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
                            </Grid2>
                            {(["en", "ar", "zh"] as const).map((k) => (
                                <Grid2 size={"grow"} key={k}>
                                    <Skeleton variant="rounded" width={'100%'} />
                                </Grid2>
                            ))}
                            {/* <Grid2 container minWidth={100} justifyContent={'center'} display={'space-around'}>
                            </Grid2> */}
                        </Grid2>
                    ))}
                </Grid2>
            )}
        </Grid2>
    )
})

export default TranslationSkeleton;